import { __decorate } from "tslib";
import { FileUploadModule } from '@blade/common/store/file-upload';
import { Component, Vue } from 'vue-property-decorator';
import EventBus, { EventKeys } from '@blade/common/utils/eventbus';
import { EType } from '@blade/common/interfaces/user-group';
import { validateOnlyAlphanumeric } from '@blade/common/utils/validate';
let default_1 = class extends Vue {
    value = '1';
    options = [];
    input1 = '';
    radioOption = '1';
    input2 = '';
    group = EType.USER;
    // get name() {
    //   return UserModule.name
    // }
    // get roles() {
    //   return UserModule.roles
    // }
    get isDisable() {
        return FileUploadModule.uploading || (!this.input1 && this.radioOption === '1') || (!this.input2 && this.radioOption === '2');
    }
    async mounted() {
        const { meta } = this.$route;
        if (meta.group) {
            this.group = meta.group;
        }
        const res = await FileUploadModule.getAllPortraitsPass(this.group);
        console.log('res:', res);
        this.mapSelect(res);
    }
    handleReset() {
        this.value = '';
    }
    handleInput() {
        console.log('input2:', this.input2);
    }
    mapSelect(options) {
        const mappedPortrait = options
            ? options.map((item) => ({
                value: item.libId,
                label: item.name,
            }))
            : [];
        console.log('mapped portrait:', mappedPortrait);
        this.options = mappedPortrait;
    }
    async handleFileChange(e) {
        const res = {
            isRestart: false,
            radioOption: this.radioOption,
            inputValue: this.radioOption === '1' ? this.input1 : this.input2,
        };
        console.log('res:', res);
        if (this.radioOption === '1') {
            if (!validateOnlyAlphanumeric(this.input1)) {
                this.$message.error(`${this.$t('passManagement.groupNameError')}`);
                return;
            }
            const isExist = await this.checkLibName();
            console.log('isExist:', isExist);
            if (isExist) {
                this.$elmessage(this.$t('isName').toString());
                return;
            }
        }
        const userParam = { libraryType: 0, personGroup: this.group };
        // FileUploadModule.updateUploading(true);
        EventBus.$emit(EventKeys.FileUpload, JSON.stringify({ ...res, ...userParam }));
    }
    async checkLibName() {
        try {
            const res = await FileUploadModule.checkLibByNamePass(this.input1);
            return res.exist;
        }
        catch (e) {
            return false;
        }
    }
};
default_1 = __decorate([
    Component({
        name: 'PhotoSearch',
        i18n: {
            messages: {
                'en-us': {
                    reset: 'Reset',
                    search: 'Search',
                    title: 'Account/Name/Phone/Email:',
                    new: 'New Portrait File',
                    existed: 'Add to existed portraint file',
                    input: 'Input Portrait Libraty Name',
                    input2: 'Select Portrait Library Name',
                    isName: 'File name exits',
                    groupNameError: 'Only alphanumeric allowed',
                    upFile: 'Upload',
                    upZip: '*  zip file',
                },
                zh: {
                    reset: '重置',
                    search: '搜索',
                    title: '账号/姓名/手机号/邮箱:',
                    new: '建为独立人像库',
                    existed: '加入已有人像库',
                    input: '输入人像库名称',
                    input2: '选择人像库名称',
                    isName: '人像库名字存在',
                    upFile: '上传',
                    upZip: '*  zip压缩格式',
                },
            },
        },
    })
], default_1);
export default default_1;
